// Prevent Google Maps from loading Roboto. We want to stay light.
var head = document.getElementsByTagName('head')[0]
var insertBefore = head.insertBefore
head.insertBefore = function (newElement, referenceElement) {
    if (newElement.href && newElement.href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0)
        return
    insertBefore.call(head, newElement, referenceElement)
}
